import React from "react";

import withTitle from "../withTitle";

import "../viewer.css";

class NotFoundView extends React.Component {
    public render() {
        return <div className="viewer-root">
            <h2>Not Found</h2>
            <p style={{ marginTop: 0 }}>
                Hmm, we're not sure how you made it here, but what you were looking for doesn't seem to be where you expected it to be...
            </p>
        </div>;
    }
}

export default withTitle("Not Found", NotFoundView);